import { useLocalizationContext } from '@im/react-localization';
import { useApiQuery } from 'mf_core/query';

export function useConfiguratorMenuQuery() {
  const { locale } = useLocalizationContext();
  return useApiQuery<ConfiguratorMenu>(
    `/cms/v1/external-host?HostType=Configurator&locale=${locale}`
  );
}
export type ConfiguratorMenu = {
  externalHost: Configurator[];
};
export type Configurator = {
  loggedInOnly: boolean;
  name: string;
  nodeAliasPath: string;
  openUrlInNewTab: boolean;
  sendLoginInformation: boolean;
  url: string;
};
